module.exports = {"420703100":"华容镇","420703101":"葛店镇","420703102":"庙岭镇","420703103":"段店镇","420703200":"临江乡","420703201":"蒲团乡","420703400":"葛店开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420703.json
// module id = 1748
// module chunks = 0